import { render } from "./post2Page.vue?vue&type=template&id=37364ac9"
import script from "./post2Page.vue?vue&type=script&lang=js"
export * from "./post2Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__